import { createSlice } from "@reduxjs/toolkit";
import { deleteCuisineAPI } from "../../api/cuisine";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const deleteCuisineSlice = createSlice({
  name: "deleteCuisine",
  initialState: data,
  reducers: {
    deleteCuisineSlice(state) {
      state.isLoading = true;
    },
    deleteCuisineSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteCuisineSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    deleteCuisineSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const deleteCuisineHandler = (id: any) => async (dispatch: any) => {
  try {
    dispatch(deleteCuisineAction.deleteCuisineSlice());
    const response: any = await deleteCuisineAPI(id);

    dispatch(deleteCuisineAction.deleteCuisineSliceSuccess(response));
  } catch (e: any) {
    dispatch(deleteCuisineAction.deleteCuisineSliceFailure(e?.response?.data));
  }
};
export default deleteCuisineSlice.reducer;
export const deleteCuisineAction = deleteCuisineSlice.actions;
